module.exports = __webpack_public_path__ + "img/足球.033440be.gif";